import React, { useState } from "react";
import styles from "../User/Auth.module.css";
import { useNavigate } from "react-router-dom";
import api from "../../api/axois";

const AffiliateRegister = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    full_name: "",
    email: "",
    phone_number: "",
    bank_name: "",
    account_number: "",
    payout_frequency: "monthly",
    agreed_to_terms: false,
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [affiliateCode, setAffiliateCode] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setAffiliateCode("");

    if (!form.agreed_to_terms) {
      setError("You must agree to the terms.");
      return;
    }

    try {
      const payload = { ...form };
      const res = await api.post("/affiliate/register", payload);
      setSuccess("Registration successful! Your affiliate code is below.");
      setAffiliateCode(res.data.affiliate_code || "");
      setTimeout(() => {
        navigate("/AffiliateDashboard");
      }, 3000);
      setForm({
        full_name: "",
        email: "",
        phone_number: "",
        bank_name: "",
        account_number: "",
        payout_frequency: "monthly",
        agreed_to_terms: false,
      });
    } catch (err) {
      let errorMessage = "Registration failed. Please try again.";
      if (err.response?.data?.message) {
        errorMessage = err.response.data.message;
      } else if (err.message) {
        errorMessage = err.message;
      }
      setError(errorMessage);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.box}>
        <h2 className={styles.heading}>Affiliate Registration</h2>
        <form className={styles.form} onSubmit={handleSubmit}>
          <div className={styles.grid}>
            <input
              type="text"
              name="full_name"
              placeholder="Full Name"
              value={form.full_name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={form.email}
              onChange={handleChange}
              required
            />
            <input
              type="text"
              name="phone_number"
              placeholder="Phone Number"
              value={form.phone_number}
              onChange={handleChange}
              required
            />
            <input
              type="text"
              name="bank_name"
              placeholder="Bank Name"
              value={form.bank_name}
              onChange={handleChange}
              required
            />
            <input
              type="text"
              name="account_number"
              placeholder="Account Number"
              value={form.account_number}
              onChange={handleChange}
              required
            />
            <select
              name="payout_frequency"
              value={form.payout_frequency}
              onChange={handleChange}
              style={{ padding: "14px", fontFamily: "Archivo, sans-serif", fontSize: "16px" }}
            >
              <option value="monthly">Monthly</option>
              <option value="weekly">Weekly</option>
            </select>
          </div>
          <label className={styles.checkbox}>
            <input
              type="checkbox"
              name="agreed_to_terms"
              checked={form.agreed_to_terms}
              onChange={handleChange}
            />{" "}
            I agree to the Affiliate Program Terms
          </label>
          {error && <div className={styles.error}>{error}</div>}
          {success && <div className={styles.success}>{success}</div>}
          {affiliateCode && (
            <div className={styles.success}>
              <strong>Your Affiliate Code:</strong> {affiliateCode}
            </div>
          )}
          <button className={styles.button} type="submit">
            REGISTER
          </button>
        </form>
      </div>
    </div>
  );
};

export default AffiliateRegister;
